var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2117",
    d: "M4.02905 9.37565C4.06138 9.66664 4.70706 10.1318 4.9254 10.3033C5.44627 10.7126 5.8723 11.3255 6.34202 11.7952C6.87716 12.3303 7.39114 12.9473 7.81191 13.5785C8.10171 14.0132 8.26966 13.5765 8.53588 13.2807C8.86726 12.9125 9.23257 12.4696 9.62028 12.165C10.292 11.6372 10.8136 10.9062 11.4506 10.3472C11.8438 10.0021 12.1831 9.60162 12.5914 9.26282C13.0347 8.89499 13.4057 8.4449 13.8012 8.03426C14.2416 7.5769 14.6552 7.08444 15.0987 6.62391C15.2335 6.48387 15.3733 6.24411 15.5374 6.14753C15.7252 6.03708 15.7952 5.74915 15.9888 5.65234",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.c81060f4ab3d7106b904f68ca241fede.svg";
export { ForwardRef as ReactComponent };